import { useNavigate } from 'react-router-dom'
import { ArrowCounterClockwise } from '@phosphor-icons/react'
import { DataTable, EmptyState, type Column } from '@/ui'
import { errorMessage } from '../../api/core'
import { useRecalledPackLots } from '../../api/recall'
import type { RecalledPackLot } from '../../model/recall/mappers'
import { Code, Status, When } from '../bits'

const LIMIT = 10

/** Pack lots on recall hold — the hold is the record (there is no separate recall log). */
export function RecalledPackLots({ page, onPage }: { page: number; onPage: (page: number) => void }) {
  const navigate = useNavigate()
  const q = useRecalledPackLots({ page, limit: LIMIT })
  const columns: Column<RecalledPackLot>[] = [
    { id: 'code', header: 'Pack lot', cell: (r) => <Code>{r.code}</Code> },
    { id: 'product', header: 'Product', cell: (r) => r.skuName ?? '—', hideBelow: 'sm' },
    { id: 'batch', header: 'Batch', cell: (r) => <Code>{r.batchCode}</Code>, hideBelow: 'md' },
    { id: 'pouches', header: 'Pouches', align: 'right', mono: true, cell: (r) => r.pouchCount },
    { id: 'out', header: 'With customers', align: 'right', mono: true, cell: (r) => r.pouchesDispatched },
    { id: 'status', header: 'State', cell: (r) => <Status status={r.status} />, hideBelow: 'sm' },
    { id: 'at', header: 'Last change', cell: (r) => <When at={r.updatedAt} />, hideBelow: 'lg' },
  ]
  return (
    <DataTable<RecalledPackLot>
      caption="Recalled pack lots"
      columns={columns}
      rows={q.data?.rows ?? []}
      getRowId={(r) => r.id}
      loading={q.isLoading}
      error={q.isError ? errorMessage(q.error) : undefined}
      onRowClick={(r) => navigate(`/c/pack-lots/${r.id}`)}
      pageSize={LIMIT}
      server={{ page, total: q.data?.total ?? 0, onPageChange: onPage }}
      empty={<EmptyState icon={<ArrowCounterClockwise />} title="Nothing recalled" description="Pack lots put on recall hold are listed here." />}
    />
  )
}
